import { render, staticRenderFns } from "./training.vue?vue&type=template&id=a891239c&scoped=true&"
import script from "./training.vue?vue&type=script&lang=js&"
export * from "./training.vue?vue&type=script&lang=js&"
import style0 from "./training.vue?vue&type=style&index=0&id=a891239c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a891239c",
  null
  
)

export default component.exports